import { Box, CircularProgress, IconButton, Paper, Tooltip, Typography } from "@mui/material"
import { WorkItemType } from "../../../shared/dtos/estimate-tree.dto";
import treeIcon from '../../../assets/tree_icon.png';
import treeGroupIcon from '../../../assets/tree_group_icon.png';
import fallenTreeIcon from '../../../assets/fallen_tree_icon.png';
import stumpIcon from '../../../assets/stump_icon.png';
import debrisPileIcon from '../../../assets/debris_pile_icon.png';
import miscellaneousIcon from '../../../assets/miscellaneous_icon.png';
import {Fence} from "@mui/icons-material";

export interface SaveAndAddNewComponentProps {
  onNewWorkItem: (workItemType: WorkItemType) => void,
  onNewGate: () => void,
  isSaving?: boolean;
  disabled?: boolean;
}

export const SaveAndAddNewComponent = ({onNewWorkItem, onNewGate, disabled, isSaving}: SaveAndAddNewComponentProps) => {
  const safeIsSaving = isSaving ?? false;
  const safeDisabled = disabled ?? false;
  return (
    <Paper 
      sx={{ 
        p: 2, 
        mt: 2, 
        elevation: 2,
        backgroundColor: 'background.default',
        border: "1px solid rgba(76, 175, 80, 0.5)",
        borderRadius: 1
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 'medium' }}>
          Save and Add New
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
        <Tooltip title="Save and Add Tree">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewWorkItem(WorkItemType.Tree)} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <img src={treeIcon} alt="Tree" style={{width: 24, height: 24}} />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Save and Add Tree Group">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewWorkItem(WorkItemType.TreeGroup)} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <img src={treeGroupIcon} alt="Tree Group" style={{width: 24, height: 24}} />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Save and Add Fallen Tree">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewWorkItem(WorkItemType.FallenTree)} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <img src={fallenTreeIcon} alt="Fallen Tree" style={{width: 24, height: 24}} />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Save and Add Stump">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewWorkItem(WorkItemType.Stump)} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <img src={stumpIcon} alt="Stump" style={{width: 24, height: 24}} />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Save and Add Debris Pile">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewWorkItem(WorkItemType.DebrisPile)} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <img src={debrisPileIcon} alt="Debris Pile" style={{width: 24, height: 24}} />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Save and Add Miscellaneous">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewWorkItem(WorkItemType.Misc)} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <img src={miscellaneousIcon} alt="Miscellaneous" style={{width: 24, height: 24}} />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Save and Add Gate">
          <IconButton 
            disabled={safeDisabled || safeIsSaving} 
            onClick={() => onNewGate()} 
            color="primary"
            sx={{ border: 1, borderColor: 'primary.main' }}
          >
            {safeIsSaving ? <CircularProgress size={24}/> : <Fence />}
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  )
}

